<template>
    <div
        :id="id"
        class="lni-c-box--content --card"
        :class="classString"
    >
        <div class="lni-u-reading-width--max lni-u-flex lni-u-justify-between">
            <div class="lni-u-mr2">
                <slot />
            </div>
            <div class="lni-u-mvauto lni-u-type--xl">
                <span
                    v-if="complaint"
                    class="lnicon--exclamation"
                    aria-hidden="true"
                />
                <span
                    v-else
                    class="lnicon--checkmark"
                    aria-hidden="true"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LniJanitorialComplaintCard',
    props: {
        id: {
            type: String,
            required: true,
        },
        classString: {
            type: String,
            default: '',
        },
        complaint: {
            type: Boolean,
            required: true,
        },
    },
};
</script>